import { render, staticRenderFns } from "./ProjectEditorList.vue?vue&type=template&id=81711114&scoped=true&"
import script from "./ProjectEditorList.vue?vue&type=script&lang=js&"
export * from "./ProjectEditorList.vue?vue&type=script&lang=js&"
import style0 from "./ProjectEditorList.vue?vue&type=style&index=0&id=81711114&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81711114",
  null
  
)

export default component.exports